import {Component, ElementRef, HostListener, OnDestroy, OnInit, Predicate, ViewChild} from '@angular/core';
import {Store} from '@ngrx/store';
import {Department, EmployeeJobCode, IEmployee, IScheduleRotation, WeekDays} from '@signal/asp-data-commons';
import {Observable, Subject} from 'rxjs';
import {LoadEmployees} from './../../store/employee/employee.actions';
import * as fromScheduleRotationActions from '../../store/schedule-rotation/schedule-rotation.actions';
//import { IDetail } from '@signal/asp-data-commons/lib/interfaces/employee';
import {ScheduleRotationState} from '../../store/schedule-rotation/schedule-rotation.reducer';
import {AddItemComponent} from '../../shared/components/add-item/add-item.component';
import { MatDialog } from '@angular/material/dialog';
import * as fromScheduleRotationSelectors from '../../store/schedule-rotation/schedule-rotation.selectors';
import {ActivatedRoute} from '@angular/router';
import {EmployeeState} from '../../store/employee/employee.reducer';
import { TranslateService } from '@ngx-translate/core';
import {selectEmployeeForSchedule} from '../../store/employee/employee.selectors';
import {v4 as uuid} from 'uuid';
import { INavigateAway } from '../../shared/guards/NavigationGuard';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { exitConfig, unsubscribeSubscriptions } from '../../shared/services/util.service';
import { SubscriptionList } from '../../shared/models/asp.types';
import { SettingsState } from '../../store/settings/settings.reducer';
import { selectSettings } from '../../store/settings/settings.selectors';
import { LoadSettings } from '../../store/settings/settings.actions';
import { HoursOfOperation } from '../../shared/models/settings.model';

@Component({
  selector: 'app-sales-schedule',
  templateUrl: './sales-schedule.component.html',
  styleUrls: ['./sales-schedule.component.scss']
})
export class SalesScheduleComponent implements OnInit,INavigateAway, OnDestroy{
  scheduleId: string;
  isEditMode: boolean;
  department = Department.SALES;
  scheduleRotations$: Observable<IScheduleRotation[]>;
  scheduleRotationsLoading$: Observable<boolean>;
  teams: Array<{id: string, name: string}> = [];
  valuesNotChanged=true;
  saveClicked=false;
  @ViewChild('form') form: ElementRef;
  clickedOutside=false;
  closedDays: Set<string> = new Set<string>();
  private subs: SubscriptionList = {};

  constructor(private readonly dialog: MatDialog,
              private translate: TranslateService,
              private readonly activatedRoute: ActivatedRoute,
              private readonly employeeState: Store<EmployeeState>,
              private readonly settingsState: Store<SettingsState>,
              private readonly scheduleRotationState: Store<ScheduleRotationState>) {
  }

  ngOnInit(): void {
    this.setupStore();
    // Generated by Copilot- Start
    this.employeeState.dispatch(new LoadEmployees());
    this.settingsState.dispatch(new LoadSettings({ department: this.department }));
    this.subs.route = this.activatedRoute.queryParams.subscribe(params => {
      this.scheduleId = params.id;
      this.isEditMode = !!this.scheduleId;
    });
    this.subs.settings = this.settingsState.select(selectSettings).subscribe(settings => {
      this.closedDays = this.getClosedDays(settings?.time?.hoursOfOperation);
    });
    // Generated by Copilot- End
    const activeAdvisorPredicate: Predicate<IEmployee> =
        (e: IEmployee) => e.department === Department.SALES
          && e.jobCode === EmployeeJobCode.ADVISOR
          && e.isActive;
    this.subs.employee = this.employeeState.select(selectEmployeeForSchedule, {predicate: activeAdvisorPredicate}).subscribe(item => {
      this.teams = item.map(({id,name}) => { return {id,name}} )
    })
  }
  canExit():Observable<boolean> { 
    const result = new Subject<boolean>();
    const dialogRef = this.dialog.open(ConfirmDialogComponent, exitConfig
      );
      
    this.subs.dialogRef = dialogRef.afterClosed().subscribe(event => {
    
      if (event.action === 'confirm') {
        this.saveClicked=true
        result.next(true);
        result.complete();
      }
      else{
        result.next(true);
        result.complete();
      }
    });
    return result.asObservable(); 
  };

  // returns if the forms are edited
  formsNotEdited()
  {
    return this.valuesNotChanged; 
  }
  
  //valuesChanged
  valuesChanged(event: boolean)
  {
    this.valuesNotChanged=event;
  }
  
  onAddNewSchedule() {
    const dialogRef = this.dialog.open(AddItemComponent, {
      width: '25rem',
      height: '18.625rem',
      panelClass: 'asp-modal-container',
      data: {isEditMode: false, title: 'scheduleRotation.addNewSchedule', type: 'schedule',clicked:true},
      disableClose:true
    });
    this.subs.scheduleDialogRef = dialogRef.afterClosed().subscribe(event => {
      if (event.action === 'confirm') {
        // Generated by Copilot- Start
        const shiftId = uuid();
        const buildDefaultDetails = () => this.teams.map((member: {id: string, name: string}) => ({ id: member.id, name: member.name }));
        const buildDayShift = (day: WeekDays) => [{
          shiftId,
          shiftName: 'Open To Close',
          detail: this.closedDays.has(this.normalizeDay(day)) ? [] : buildDefaultDetails()
        }];
        const week = {
          [WeekDays.MONDAY]: buildDayShift(WeekDays.MONDAY),
          [WeekDays.TUESDAY]: buildDayShift(WeekDays.TUESDAY),
          [WeekDays.WEDNESDAY]: buildDayShift(WeekDays.WEDNESDAY),
          [WeekDays.THURSDAY]: buildDayShift(WeekDays.THURSDAY),
          [WeekDays.FRIDAY]: buildDayShift(WeekDays.FRIDAY),
          [WeekDays.SATURDAY]: buildDayShift(WeekDays.SATURDAY),
          [WeekDays.SUNDAY]: buildDayShift(WeekDays.SUNDAY),
        };
        // Generated by Copilot- End
        const payload : IScheduleRotation = {
          id : uuid(),
          by : 'employee',
          department : this.department,
          name : event.data.name,
          rotation : [week],
          // Generated by Copilot- Start
          shifts: [],
          startDate : ""
        }
        payload.shifts.push({
          id : shiftId,
          fromTime : "Operational hours",
          name : "Open To Close",
          toTime : "Operational hours"
        })
        // Generated by Copilot- End
        this.scheduleRotationState.dispatch(new fromScheduleRotationActions.AddScheduleRotation({
          department: this.department, name: event.data.name, payload:payload
        }));
      }
    });
  }

  private setupStore() {
    /* Store actions dispatchers */
    this.dispatchActions();
    this.scheduleRotationsLoading$ = this.scheduleRotationState.select(fromScheduleRotationSelectors.selectScheduleRotationLoading, {
      department: Department.SALES
    });
    this.scheduleRotations$ = this.scheduleRotationState.select(fromScheduleRotationSelectors.selectScheduleRotationsByStartDate, {
      department: Department.SALES,
      id: undefined
    });
  }

  private dispatchActions() {
    this.scheduleRotationState.dispatch(new fromScheduleRotationActions.LoadScheduleRotation({department: Department.SALES}));
  }

  private getClosedDays(hoursOfOperation: HoursOfOperation[] = []): Set<string> {
    return new Set((hoursOfOperation || [])
      .filter(entry => (entry?.operation || '').toLowerCase() === 'closed')
      .map(entry => this.normalizeDay(entry?.day))
      .filter(day => !!day));
  }

  private normalizeDay(day: string): string {
    const normalized = (day || '').toLowerCase();
    // Generated by Copilot- Start
    // Map abbreviated day names (from hoursOfOperation) to full names (matching WeekDays enum)
    const abbrevToFullDay: { [key: string]: string } = {
      'mon': 'monday',
      'tue': 'tuesday',
      'wed': 'wednesday',
      'thu': 'thursday',
      'fri': 'friday',
      'sat': 'saturday',
      'sun': 'sunday'
    };
    return abbrevToFullDay[normalized] || normalized;
    // Generated by Copilot- End
  }

  ngOnDestroy() {
    unsubscribeSubscriptions(this.subs);
  }

}

